
export enum ChronicDisease {
    chronicDisease,
    asthma,
    hypertension,
    copd,
    diabetes
}

export enum QualityMeasures {
    AWV ="AWV",
    APE = "APE",
    INI = "INI",
    TUS = "TUS",
    FFS = "FFS",
    COA = "COA",
    BMF = "BMF",
}

export interface PatientPreview {
    clinicId: number,
    accountId: number,
    mpid: number,
    patientId: number,
    name: string,
    dob: string,
    gender: string,
    mobilePhone: string,
    homePhone: string,
    email: string,
    lastVisit: string,
    chronicDisease: Array<ChronicDisease>,
    qualityMeasures: Array<string>,
    lastAttempt: string
}
